import React, { ReactNode } from 'react';
import { HorizontalLayout, MainContainer, VerticalLayout } from '../common/common-layout';
import MainLeftMenu from './MainLeftMenu';
import MainTopMenu from './MainTopMenu';
import { TitleNormal, TitleNormalBold } from '../common/common-text';
import ArrowSmallGrey from '../assets/icons/arrow_small_grey.svg';
import BTBox from '../common/components/BTBox';
import theme from '../common/theme';
import { homeMenuStore } from '../store/HomeMenuStore';
import { observer } from 'mobx-react-lite';
import BaseLayout from './BaseLayout';

interface MainLayoutProps {
    isMainPage?: boolean;
    children: ReactNode;  // AdminBody 또는 다른 컴포넌트를 children으로 받음
}

export const MAIN_RIGHT_TOP_HEIGHT = '142px'

const MainLayout: React.FC<MainLayoutProps> = observer(({ children, isMainPage = false }) => {
    return (
        <div>
            <BaseLayout>
                <MainContainer style={{ height: '100vh' }} backgroundColor='#FAFAFA'>
                    <HorizontalLayout style={{ height: '100%', flex: 1, overflowY: 'auto' }}>
                        <MainLeftMenu />
                        <VerticalLayout>
                            <div style={{ width: '100%', height: '76px' }}>
                                <MainTopMenu />
                            </div>
                            { isMainPage ?
                                <div />
                                :
                                <HorizontalLayout style={{ height: 'auto', justifyContent: 'flex-end', alignItems: 'center' }} paddingTop={38} paddingRight={36} paddingBottom={10}>
                                    <TitleNormal style={{ color: theme.colors.textCancel }}>{homeMenuStore.getSelectionName()}</TitleNormal>
                                    <BTBox width='8px' />
                                    <img src={ArrowSmallGrey} />
                                    <BTBox width='8px' />
                                    <TitleNormalBold style={{ color: theme.colors.bbTech }}>{homeMenuStore.getSelectedItemName()}</TitleNormalBold>
                                </HorizontalLayout>
                            }
                            <div style={{ flex: 1, display: 'flex', width: '100%', overflowY: 'auto' }}>
                                {children} {/* 여기에서 children으로 전달된 AdminBody 또는 다른 컴포넌트를 동적으로 렌더링 */}
                            </div>
                        </VerticalLayout>
                    </HorizontalLayout>
                </MainContainer>
            </BaseLayout>
        </div>
    );
});

export default MainLayout;
